import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { userSlice } from "./slices/user.slice"; // Make sure this import is correct
import { uiSlice } from "./slices/ui.slice"; // Make sure this import is correct
import apiSlice from "../services/api/api";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from 'redux-persist/lib/storage';
import hardSet from "redux-persist/es/stateReconciler/hardSet";

const persistConfig = {
  key: "root",
  storage,
  version: 1,
  stateReconciler: hardSet,
  blacklist: apiSlice.reducerPath,
};

const rootReducer = combineReducers({
  user: userSlice.reducer, // Access the 'reducer' property of the userSlice
  ui: uiSlice.reducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(apiSlice.middleware),
});

const persistor = persistStore(store);

export default store;
export { persistor };
